module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Framen",
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "ebook-toc",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _vm._v("prologue")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("To heal from your pain")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("now,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("you need to go all the way back")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("to chapter one.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("To page one.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("To the beginning")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("of how it all began.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal t1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("For every ending,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("there is a ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "poem-itals CharOverride-2"
  }, [_vm._v("once upon a time")]), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("For every broken soul,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("there is a ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "poem-itals CharOverride-2"
  }, [_vm._v("once upon a happy soul. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("For every phoenix soaring, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("there is a phoenix ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("burning,")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("turning to ashes, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("rising, ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("then soaring.")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal t1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Let me hand you the matches ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("to ignite the glory ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("within your soul. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Let me be the one ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("who burns to ashes ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("as you spark in your darkest of nights. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("As you rise. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("As you soar.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5aa297d3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SparksPhoenix_epub3.vue
// module id = 66
// module chunks = 0